module.exports = __webpack_public_path__ + "img/logo.7f1a8a7e.png";